import { render, staticRenderFns } from "./InquiryDetailCoverageSummary.vue?vue&type=template&id=196abc88&scoped=true"
import script from "./InquiryDetailCoverageSummary.vue?vue&type=script&lang=js"
export * from "./InquiryDetailCoverageSummary.vue?vue&type=script&lang=js"
import style0 from "./InquiryDetailCoverageSummary.vue?vue&type=style&index=0&id=196abc88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196abc88",
  null
  
)

export default component.exports